"use client";

import Link from "next/link";
import { useEffect, useState } from "react";

/**
 * Bandeau d'information sur les cookies (art. 82 loi Informatique et Libertés,
 * lignes directrices CNIL du 17 septembre 2020). Le site ne dépose que des
 * cookies exemptés de consentement (session, sécurité, préférences choisies
 * par l'utilisateur) : une information suffit, sans bouton « Refuser ».
 * Tout ajout d'un traceur non exempté (mesure d'audience non exemptée,
 * publicité, contenu tiers) impose de remplacer ce bandeau par un vrai recueil
 * du consentement, avec refus aussi simple que l'acceptation.
 *
 * Changer VERSION réaffiche le bandeau (nouvelle liste de cookies).
 */
const CLE = "bandeau-cookies";
const VERSION = "1";

export function BandeauCookies() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      setVisible(localStorage.getItem(CLE) !== VERSION);
    } catch {
      setVisible(true);
    }
  }, []);

  function fermer() {
    setVisible(false);
    try {
      localStorage.setItem(CLE, VERSION);
    } catch {
      // Stockage indisponible (navigation privée) : le bandeau reviendra.
    }
  }

  if (!visible) return null;
  return (
    <div
      role="region"
      aria-label="Information sur les cookies"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-surface/95 px-4 py-3 shadow-lg backdrop-blur print:hidden"
      style={{ paddingBottom: "max(0.75rem, env(safe-area-inset-bottom))" }}
    >
      <div className="mx-auto flex max-w-5xl flex-col gap-3 text-sm sm:flex-row sm:items-center">
        <p className="flex-1 leading-snug text-muted">
          <span className="font-medium text-text">Cookies : </span>
          ce site n&apos;utilise que des cookies nécessaires à son fonctionnement (connexion, sécurité) et à vos
          préférences d&apos;affichage. Aucune mesure d&apos;audience ni publicité : ils ne demandent pas votre
          consentement.{" "}
          <Link href="/confidentialite#cookies" className="link whitespace-nowrap">
            En savoir plus
          </Link>
        </p>
        <button type="button" onClick={fermer} className="btn btn-primary btn-sm self-end sm:self-auto">
          J&apos;ai compris
        </button>
      </div>
    </div>
  );
}
